<template src="../../../components/shared/physicianSearch/BaseSearchMap.html">

</template>

<script>
    import {baseSearchMapMixin} from "../../../components/shared/mixins/baseSearchMap.js";

    export default {
        name: "SearchMap",
        mixins: [baseSearchMapMixin],
        props: {additionalData: {type: [Object], required: true}},
        async mounted() {
            this.baseInit();
        }
    }
</script>

<style scoped>

</style>